// a react module that uses Html2Image to generate a preview image
// The component mounts two instances of Viewerati, previews every page in the code and creates an SVG for each one.

import { strings } from "@quickpoint.me/shared";
import { Suspense } from "react";
import { IsInPortrait } from "../../state/selectors";
import { ShowLandscapePreview, ShowPortraitPreview } from "../../state/uiAtoms";

import { useRecoilValue } from "recoil";
import styled from "styled-components";
import RefreshSpinner from "../Refresh";
import PreviewGenerator from "./PreviewerGenerator";

const StyledRenderPreviewGenerator = styled.div<{ $landscape: boolean }>`
    align-items: center;
    background: #FFF;
    border: 1px solid #DDD;
    height: ${(props) => (props.$landscape ? "100px" : "168px")};
    justify-content: center;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: ${(props) => (props.$landscape ? "168px" : "100px")};
    .preview-generator {
        width: 100%;
        height: 100%;
    }
    z-index: -1000;
    `;

export const previewerFilter = (node: HTMLElement) => {
	const exclusionClasses = ["sr-only"];
	return !exclusionClasses.some((classname) =>
		node.classList?.contains(classname),
	);
};

function RenderPreview() {
	const showPortraitPreview = useRecoilValue(ShowPortraitPreview);
	const showLandscapePreview = useRecoilValue(ShowLandscapePreview);
	const isInPortrait = useRecoilValue(IsInPortrait);

	// Don't render the generator if no preview is visible
	if (!showLandscapePreview && !showPortraitPreview) return null;

	// Decouple generator from visibility. If in Landscape UI, generate Landscape thumbnails.
	const isLandscape = !isInPortrait;
	const cssId = isLandscape
		? strings.css.landscapePreviewGeneratorID
		: strings.css.portraitPreviewGeneratorID;

	return (
		<Suspense fallback={<RefreshSpinner showBackGround={true} />}>
			<StyledRenderPreviewGenerator
				className={strings.css.previewGenerator}
				$landscape={isLandscape}
			>
				<PreviewGenerator
					$showPortraitPreview={showPortraitPreview}
					$showLandscapePreview={showLandscapePreview}
					landscape={isLandscape}
					cssId={cssId}
				/>
			</StyledRenderPreviewGenerator>
		</Suspense>
	);
}

export default RenderPreview;
